import React, { useState, useEffect, useRef } from "react";
import WorkerHeader from '../../worker-header/components/index';
import WorkerFooter from "../../worker-footer/components/index";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addSnapshot } from "../slice/workerSnapshotSlice";
import { useNavigate } from "react-router-dom";
import "../style/chat.css";
const BACKEND_URL = process.env.REACT_APP_NODE_API;

const WorkerBotChat = () => {
  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [label, setLabel] = useState("");
  const [fields, setFields] = useState([]);
  const [step, setStep] = useState(1);
  // const [completed, setCompleted] = useState(false);
  const [completedData, setCompletedData] = useState(false);
  const [finaldata, setFinaldata] = useState(null);
  const inputRef = useRef(null);
  const scrollRef = useRef(null);
  const [type, setType] = useState("text");
  const [options, setOptions] = useState([]);
  const [title, setTitle] = useState("");
  const [totalSteps, setTotalSteps] = useState(0);
  const [chatHistory, setChatHistory] = useState([]);
  const chatContainerRef = useRef(null);
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [onboardingStatus, setOnboardingStatus] = useState(null);
  const modalRef = useRef(null);
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  const [timeLeft, setTimeLeft] = useState(30);
  const [submittedSnapshot, setSubmittedSnapshot] = useState(null);
  const snapshotStartedRef = useRef(false);
  const navigate = useNavigate();
  const [marketingConsent, setMarketingConsent] = useState(false);

  //   useEffect(() => {
  //   const cookieValue = document.cookie
  //     .split("; ")
  //     .find((cookie) => cookie.startsWith("ncaf_traffic_source="));

  //   console.log(
  //     "ncaf_traffic_source cookie:",
  //     cookieValue ? decodeURIComponent(cookieValue.split("=").slice(1).join("=")) : null
  //   );
  // }, []);

  const getTrafficSourceCookie = () => {
    try {
      const cookieValue = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith("ncaf_traffic_source="));

      if (!cookieValue) return null;

      const rawValue = decodeURIComponent(cookieValue.split("=").slice(1).join("="));
      return JSON.parse(rawValue);
    } catch (error) {
      console.error("Failed to parse ncaf_traffic_source cookie:", error);
      return null;
    }
  };

  const getActiveAttribution = () => {
    const cookieData = getTrafficSourceCookie();
    if (cookieData) {
      return {
        utm_source: cookieData.utm_source || null,
        utm_medium: cookieData.utm_medium || null,
        utm_campaign: cookieData.utm_campaign || null,
        utm_content: cookieData.utm_content || null,
        utm_term: cookieData.utm_term || null,
        referrer: cookieData.referrer_url || null,
        landing_page_url: cookieData.landing_page_url || window.location.href,
      };
    }

    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_content: params.get("utm_content"),
      utm_term: params.get("utm_term"),
      referrer: document.referrer || null,
      landing_page_url: window.location.href,
    };
  };

  const params = new URLSearchParams(window.location.search);
  // ✅ Get UTM params from URL
  const getUTMParams = () => {
    // console.log("params", params);

    return {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_content: params.get("utm_content"),
      utm_term: params.get("utm_term"),
    };
  };

  // ✅ Initialize attribution (only once)
  // const initAttribution = () => {
  //   console.log("initAttribution called");
  //   const existing = localStorage.getItem("utm_data");
  //   console.log("existing", existing);

  //   if (!existing) {
  //     const data = {
  //       ...getUTMParams(),
  //       referrer: document.referrer || null,
  //       landing_page_url: window.location.href,
  //     };

  //     localStorage.setItem("utm_data", JSON.stringify(data));
  //   }
  // };

  const initAttribution = () => {
    const existing = localStorage.getItem("utm_data");

    if (!existing) {
      const cookieData = getTrafficSourceCookie();

      if (cookieData) {
        const data = {
          utm_source: cookieData.utm_source || null,
          utm_medium: cookieData.utm_medium || null,
          utm_campaign: cookieData.utm_campaign || null,
          utm_content: cookieData.utm_content || null,
          utm_term: cookieData.utm_term || null,
          referrer: cookieData.referrer_url || null,
          landing_page_url: cookieData.landing_page_url || window.location.href,
        };
        localStorage.setItem("utm_data", JSON.stringify(data));
        return;
      }

      const params = new URLSearchParams(window.location.search);
      const fallbackData = {
        utm_source: params.get("utm_source"),
        utm_medium: params.get("utm_medium"),
        utm_campaign: params.get("utm_campaign"),
        utm_content: params.get("utm_content"),
        utm_term: params.get("utm_term"),
        referrer: document.referrer || null,
        landing_page_url: window.location.href,
      };

      localStorage.setItem("utm_data", JSON.stringify(fallbackData));
    }
  };

  // ✅ Get stored attribution
  const getAttribution = () => {
    return JSON.parse(localStorage.getItem("utm_data") || "{}");
  };

  // useEffect(() => {
  //   window.dataLayer = window.dataLayer || [];

  //   // ✅ Initialize attribution
  //   initAttribution();

  //   window.dataLayer.push({
  //     event: "benefits_landing_view",
  //     utm_source: params.get("utm_source"),
  //     utm_medium: params.get("utm_medium"),
  //     utm_campaign: params.get("utm_campaign"),
  //     utm_content: params.get("utm_content"),
  //     utm_term: params.get("utm_term"),
  //     referrer: document.referrer || null,
  //     landing_page_url: window.location.href,
  //   });

  // }, []);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    initAttribution();
    const attribution = getAttribution();

    window.dataLayer.push({
      event: "benefits_landing_view",
      utm_source: attribution.utm_source,
      utm_medium: attribution.utm_medium,
      utm_campaign: attribution.utm_campaign,
      utm_content: attribution.utm_content,
      utm_term: attribution.utm_term,
      referrer: attribution.referrer,
      landing_page_url: attribution.landing_page_url,
    });
  }, []);

  const defaultAnswers = {
    providerType: "1",
    numLocations: "1",
    stateOfOperation: "AL",
    totalStaff: "1",
    roles: ["5"],
    backgroundCheck: "4",
    cpr: "4",
    training: "3",
    licensing: "4",
    documentationConfidence: "4",
    workforceChallenges: ["4"],
    futureInterest: ["3"]
  };

  // useEffect(() => {
  //   // ❌ skip timer for text input
  //   if (!fields || fields.length === 0 || completedData || type === "text") return;

  //   // reset timer UI
  //   setTimeLeft(30);

  //   if (timerRef.current) clearTimeout(timerRef.current);

  //   let interval;

  //   // countdown
  //   interval = setInterval(() => {
  //     setTimeLeft(prev => {
  //       if (prev <= 1) {
  //         clearInterval(interval);
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);

  //   // auto submit
  //   timerRef.current = setTimeout(() => {
  //     // console.log("⏰ Time खत्म — auto select");

  //     const field = fields[0];
  //     const defaultValue = defaultAnswers[field];

  //     if (!defaultValue) return;

  //     if (type === "radio" || type === "dropdown") {
  //       handleRadioSelect(defaultValue);
  //     } else if (type === "checkbox") {
  //       setInput(defaultValue);
  //       setTimeout(() => handleSend(defaultValue), 100);
  //     }

  //   }, 30000);

  //   return () => {
  //     clearTimeout(timerRef.current);
  //     clearInterval(interval);
  //   };

  // }, [step, type]); // ✅ include type

  const stateOfOperation = [
    { id: 1, value: 'AL', label: 'Alabama' },
    { id: 2, value: 'AK', label: 'Alaska' },
    { id: 3, value: 'AZ', label: 'Arizona' },
    { id: 4, value: 'AR', label: 'Arkansas' },
    { id: 5, value: 'CA', label: 'California' },
    { id: 6, value: 'CO', label: 'Colorado' },
    { id: 7, value: 'CT', label: 'Connecticut' },
    { id: 8, value: 'DE', label: 'Delaware' },
    { id: 9, value: 'FL', label: 'Florida' },
    { id: 10, value: 'GA', label: 'Georgia' },
    { id: 11, value: 'HI', label: 'Hawaii' },
    { id: 12, value: 'ID', label: 'Idaho' },
    { id: 13, value: 'IL', label: 'Illinois' },
    { id: 14, value: 'IN', label: 'Indiana' },
    { id: 15, value: 'IA', label: 'Iowa' },
    { id: 16, value: 'KS', label: 'Kansas' },
    { id: 17, value: 'KY', label: 'Kentucky' },
    { id: 18, value: 'LA', label: 'Louisiana' },
    { id: 19, value: 'ME', label: 'Maine' },
    { id: 20, value: 'MD', label: 'Maryland' },
    { id: 21, value: 'MA', label: 'Massachusetts' },
    { id: 22, value: 'MI', label: 'Michigan' },
    { id: 23, value: 'MN', label: 'Minnesota' },
    { id: 24, value: 'MS', label: 'Mississippi' },
    { id: 25, value: 'MO', label: 'Missouri' },
    { id: 26, value: 'MT', label: 'Montana' },
    { id: 27, value: 'NE', label: 'Nebraska' },
    { id: 28, value: 'NV', label: 'Nevada' },
    { id: 29, value: 'NH', label: 'New Hampshire' },
    { id: 30, value: 'NJ', label: 'New Jersey' },
    { id: 31, value: 'NM', label: 'New Mexico' },
    { id: 32, value: 'NY', label: 'New York' },
    { id: 33, value: 'NC', label: 'North Carolina' },
    { id: 34, value: 'ND', label: 'North Dakota' },
    { id: 35, value: 'OH', label: 'Ohio' },
    { id: 36, value: 'OK', label: 'Oklahoma' },
    { id: 37, value: 'OR', label: 'Oregon' },
    { id: 38, value: 'PA', label: 'Pennsylvania' },
    { id: 39, value: 'RI', label: 'Rhode Island' },
    { id: 40, value: 'SC', label: 'South Carolina' },
    { id: 41, value: 'SD', label: 'South Dakota' },
    { id: 42, value: 'TN', label: 'Tennessee' },
    { id: 43, value: 'TX', label: 'Texas' },
    { id: 44, value: 'UT', label: 'Utah' },
    { id: 45, value: 'VT', label: 'Vermont' },
    { id: 46, value: 'VA', label: 'Virginia' },
    { id: 47, value: 'WA', label: 'Washington' },
    { id: 48, value: 'WV', label: 'West Virginia' },
    { id: 49, value: 'WI', label: 'Wisconsin' },
    { id: 50, value: 'WY', label: 'Wyoming' },
  ];
  const providerType = [
    { id: 1, value: '1', label: 'Licensed Childcare Center' },
    { id: 2, value: '2', label: 'Family / Home-Based Childcare' },
    { id: 3, value: '3', label: 'License-Exempt / Informal Care' }
  ]

  const numLocations = [
    { id: 1, value: '1', label: '1' },
    { id: 1, value: '2', label: '2-5' },
    { id: 1, value: '3', label: '6+' },
  ];
  const totalStaff = [
    { id: 1, value: '1', label: '1-5' },
    { id: 1, value: '2', label: '6-15' },
    { id: 1, value: '3', label: '16-30' },
    { id: 1, value: '4', label: '30+' },
  ];

  const roles = [
    { label: "Director / Administrator", value: "1" },
    { label: "Lead Teachers", value: "2" },
    { label: "Assistant Teachers / Aides", value: "3" },
    { label: "Substitutes / Floaters", value: "4" },
    { label: "Support Staff (non-classroom)", value: "5" },
  ];

  const backgroundCheck = [
    { label: "Within the last 12 months", value: "1" },
    { label: "1–2 years ago", value: "2" },
    { label: "More than 2 years ago", value: "3" },
    { label: "Not sure", value: "4" }
  ];
  const cpr = [
    { label: "Within the next 30 days", value: "1" },
    { label: "1–6 months", value: "2" },
    { label: "More than 6 months", value: "3" },
    { label: "Not sure", value: "4" }
  ];
  const training = [
    { label: "Within the last 12 months", value: "1" },
    { label: "More than 12 months ago", value: "2" },
    { label: "Not sure", value: "3" }
  ];
  const licensing = [
    { label: "Within the last year", value: "1" },
    { label: "1–2 years ago", value: "2" },
    { label: "More than 2 years ago", value: "3" },
    { label: "Not applicable / Not sure", value: "4" }
  ];

  const documentationConfidence = [
    { label: "Very confident", value: "1" },
    { label: "Somewhat confident", value: "2" },
    { label: "Not confident", value: "3" },
    { label: "Not sure", value: "4" }
  ];

  const workforceChallenges = [
    { label: "Staff turnover", value: "1" },
    { label: "Coverage gaps / call-outs", value: "2" },
    { label: "Difficulty onboarding new hires", value: "3" },
    { label: "None of the above", value: "4" }
  ];

  const futureInterest = [
    { label: "Proficient Compliant Childcare Provider support", value: "1" },
    { label: "Payroll Management Services", value: "2" },
    { label: "Substitute Teacher / Support Staff Portal", value: "3" },
  ];

  const optionMap = {
    providerType,
    stateOfOperation,
    numLocations,
    totalStaff,
    roles,
    backgroundCheck,
    cpr,
    training,
    licensing,
    documentationConfidence,
    workforceChallenges,
    futureInterest
  };

  useEffect(() => {
    if (reviewData && modalRef.current) {
      const modal = new window.bootstrap.Modal(modalRef.current);
      modal.show();
    }
  }, [reviewData]);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }

    const lastMessage = messages[messages.length - 1];
    if (lastMessage && lastMessage.type === "bot") {
      speak(lastMessage.text);
    }
  }, [messages]);

  // Speak function
  const speak = (text) => {
    if (!('speechSynthesis' in window) || !text) return;

    const synth = window.speechSynthesis;

    const speakNow = () => {
      const voices = synth.getVoices();
      // console.log("voices", voices);

      const femaleVoice = voices.find(voice =>
        voice.lang === "en-US" && /female|Google/i.test(voice.name)
      );

      // console.log("female voice", femaleVoice);

      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-US";
      utterance.rate = 1;
      utterance.pitch = 1;

      if (femaleVoice) {
        utterance.voice = femaleVoice;
      }

      synth.cancel();
      synth.speak(utterance);
    };

    // ✅ If voices already loaded
    if (synth.getVoices().length > 0) {
      speakNow();
    } else {
      // ⏳ Wait for voices
      synth.onvoiceschanged = () => {
        speakNow();
      };
    }
  };

  const startListening = () => {
    if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
      alert("Speech Recognition not supported in this browser.");
      return;
    }

    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript.trim();
      // console.log("Transcript:", transcript);

      // Handle speech based on input type
      if (type === "text") {
        setInput(transcript);
      } else if (type === "radio" || type === "dropdown") {
        const match = options.find(
          opt => (opt.label || opt).toLowerCase() === transcript.toLowerCase()
            || (opt.value || opt).toLowerCase() === transcript.toLowerCase()
        );
        if (match) handleRadioSelect(match.value || match.label || match);
      } else if (type === "checkbox") {
        // For checkboxes, select all matching options
        const matches = options.filter(
          opt => (opt.label || opt).toLowerCase() === transcript.toLowerCase()
            || (opt.value || opt).toLowerCase() === transcript.toLowerCase()
        );
        if (matches.length > 0) {
          const selectedValues = matches.map(m => m.value || m.label || m);
          setInput(selectedValues);
        }
      }

      setListening(false);
    };

    recognition.onend = () => setListening(false);

    recognition.start();
    setListening(true);
    recognitionRef.current = recognition;
  };

  const progressPercent = completedData
    ? 100
    : totalSteps
      ? Math.round(((step - 1) / totalSteps) * 100)
      : 0;

  // Scroll chat to bottom when messages update
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const questionLabels = {
    providerType: "Provider Type",
    stateOfOperation: "State of Operation",
    numLocations: "Number of Locations",
    totalStaff: "Total Staff",
    roles: "Staff Roles",
    backgroundCheck: "Background Check",
    cpr: "CPR Certification",
    training: "Training",
    licensing: "Licensing",
    documentationConfidence: "Documentation Confidence",
    workforceChallenges: "Workforce Challenges",
    futureInterest: "Future Interest",
  };

  const getAnswerLabel = (question, answer) => {
    const options = optionMap[question];

    if (!options) return answer;

    // Multiple answers
    if (Array.isArray(answer)) {
      return answer
        .map(value => options.find(o => o.value === value)?.label || value)
        .join(", ");
    }

    // Single answer
    return options.find(o => o.value === answer)?.label || answer;
  };

  const submitSnapshot = async () => {
    const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    if (modal) modal.hide();
    try {
      setLoading(true);
      const finalData = {
        step0: {
          stateOfOperation: finaldata.stateOfOperation,
          providerType: finaldata.providerType,
          numLocations: finaldata.numLocations || "3",
          totalStaff: finaldata.totalStaff || "4",
        },
        step1: {
          roles: finaldata.roles.length
            ? finaldata.roles
            : ["5"],
        },
        step2: {
          backgroundCheck: finaldata.backgroundCheck || "4",
          cpr: finaldata.cpr || "4",
          training: finaldata.training || "3",
          licensing: finaldata.licensing || "4",
        },
        step3: {
          documentationConfidence:
            finaldata.documentationConfidence || "4",
        },
        step4: {
          workforceChallenges:
            finaldata.workforceChallenges.length
              ? finaldata.workforceChallenges
              : ["4"],
        },
        step5: {
          futureInterest: finaldata.futureInterest?.length
            ? finaldata.futureInterest
            : ["1"],
        },
        step6: {
          email: finaldata.email,
          center_name: finaldata.center_name,
          zip_code: finaldata.zip_code
        }
      };

      console.log("Final Payload:", finalData);

      const answers = [];

      // STEP 0
      Object.entries(finalData.step0).forEach(([key, value]) => {
        answers.push({
          que_name: key,
          answer: value,
        });
      });

      // STEP 1 (roles multiple)
      finalData.step1.roles.forEach((role) => {
        answers.push({
          que_name: "roles",
          answer: role,
        });
      });

      // STEP 2
      Object.entries(finalData.step2).forEach(([key, value]) => {
        answers.push({
          que_name: key,
          answer: value,
        });
      });

      // STEP 3
      answers.push({
        que_name: "documentationConfidence",
        answer: finalData.step3.documentationConfidence,
      });

      // STEP 4 (multiple)
      finalData.step4.workforceChallenges.forEach((val) => {
        answers.push({
          que_name: "workforceChallenges",
          answer: val,
        });
      });

      // STEP 5 (multiple)
      finalData.step5.futureInterest.forEach((val) => {
        answers.push({
          que_name: "futureInterest",
          answer: val,
        });
      });

      const attribution = getAttribution();

      const payload = {
        acknowledgment: finalData.step6.acknowledgment,
        center_name: finalData.step6.center_name,
        email: finalData.step6.email,
        zip_code: finalData.step6.zip_code,
        marketing_consent: marketingConsent,
        answers,
        // ✅ ADD THIS BLOCK
        attribution,
        snapshot_started_at: sessionStorage.getItem("snapshot_started_at"),
        snapshot_completed_at: new Date().toISOString()
      };

      const submittedData = {
        center_name: payload.center_name,
        email: payload.email,
        zip_code: payload.zip_code,
        acknowledgment: payload.acknowledgment,
        answers: payload.answers.map(item => ({
          question: item.que_name,
          answer: getAnswerLabel(item.que_name, item.answer)
        }))
      };

      setSubmittedSnapshot(submittedData);

      // console.log("Final API Payload:", payload);

      const result = await dispatch(addSnapshot(payload));
      // if (result.meta.requestStatus === "fulfilled") {

      //   setMessages([]);
      //   setReviewData(null);
      //   setCompletedData(false);
      //   setInput("");
      //   setType("");
      //   setLoading(false);
      //   setOnboardingStatus("success");

      //   toast.success("Snapshot stored successfull", {
      //     position: "top-right",
      //     autoClose: 2000,
      //     style: { fontSize: "0.85rem" },
      //   });
      // }
      if (result.meta.requestStatus === "fulfilled") {
        const attribution = getAttribution();

        // ✅ FIRE COMPLETED EVENT
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "benefits_snapshot_completed",
          utm_source: attribution.utm_source,
          utm_medium: attribution.utm_medium,
          utm_campaign: attribution.utm_campaign,
          utm_content: attribution.utm_content,
          utm_term: attribution.utm_term,
          referrer: attribution.referrer,
          landing_page_url: attribution.landing_page_url,
          sessionId: sessionId,
          status: "success"
        });

        sessionStorage.removeItem("snapshot_started_at");
        localStorage.removeItem("utm_data"); // optional (see above)

        setSubmittedSnapshot(payload); // Save submitted data

        setMessages([]);
        setReviewData(null);
        setCompletedData(false);
        setInput("");
        setType("");
        setLoading(false);
        setOnboardingStatus("success");

        toast.success("Snapshot stored successfully", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
      }
      else {

        setMessages([]);
        setReviewData(null);
        setCompletedData(false);
        setInput("");
        setType("");
        setLoading(false);
        setOnboardingStatus("failed");
        toast.error("Applicant failed.", {
          position: "top-right",
          autoClose: 2000,
          style: { fontSize: "0.85rem" },
        });
      }


    } catch (err) {
      console.error(err);
    }
  };

  // Start bot on mount
  useEffect(() => {
    const startBot = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/snapshot/start`, {
          method: "POST",
        });
        const data = await res.json();

        setSessionId(data.sessionId);
        setFields(data.fields);
        setType(data.type || "text");
        setStep(data.step);
        setOptions(data.options || []);
        setTitle(data.title);
        setOnboardingStatus(null);
        setTotalSteps(data.totalSteps);
        setMessages([{ type: "bot", text: data.message }]);
      } catch (err) {
        console.error(err);
      }
    };
    startBot();
  }, []);

  const handleRadioSelect = async (selectedOption) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    console.log("selectedOption", selectedOption);
    const value = typeof selectedOption === "object"
      ? selectedOption.value
      : selectedOption;

    const modal = window.bootstrap.Modal.getInstance(modalRef.current);
    if (modal) modal.hide();

    // Show user message
    // setMessages(prev => [...prev, { type: "user", text: selectedOption.label }]);
    // setMessages(prev => [...prev, { type: "user", text: value === "change" ? "Change Something" : typeof selectedOption === "object" ? selectedOption.label : value }]);
    //   const value =
    // typeof selectedOption === "object"
    //   ? selectedOption.value
    //   : selectedOption;

    // 🔥 ALWAYS resolve label
    const selected = options.find(opt => opt.value === value);

    const displayText = selected
      ? selected.label
      : value;

    setMessages(prev => [
      ...prev,
      { type: "user", text: displayText }
    ]);

    // const stepData = {};
    // fields.forEach(field => {
    //   stepData[field] = value;
    // });

    const stepData = {};

    if (fields && fields.length > 0) {
      fields.forEach(field => {
        stepData[field] = value;
      });
    } else {
      // fallback
      stepData["reviewAction"] = value;
    }

    if (!snapshotStartedRef.current) {
      const attribution = getActiveAttribution();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "benefits_snapshot_started",
        utm_source: attribution.utm_source,
        utm_medium: attribution.utm_medium,
        utm_campaign: attribution.utm_campaign,
        utm_content: attribution.utm_content,
        utm_term: attribution.utm_term,
        referrer: attribution.referrer,
        landing_page_url: attribution.landing_page_url,
      });

      if (!sessionStorage.getItem("snapshot_started_at")) {
        sessionStorage.setItem(
          "snapshot_started_at",
          new Date().toISOString()
        );
      }

      snapshotStartedRef.current = true;
    }

    try {
      const res = await fetch(`${BACKEND_URL}/snapshot/step`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sessionId,
          stepData
        })
      });

      const data = await res.json();

      console.log("data", data);

      if (data.completed) {
        // setMessages(prev => [...prev, { type: "bot", text: data.message }]);
        // setCompleted(true);setCompleted
        setCompletedData(true);
        setFinaldata(data.data);
        return;
      }

      if (data.reviewData) {
        setReviewData(data.reviewData);
        setFinaldata(data.reviewData);
      }

      setFields(data.fields);
      setType(data.type || "text");
      setOptions(data.options || []);
      setTitle(data.title);
      setStep(data.step);
      setMessages(prev => [...prev, { type: "bot", text: data.message }]);

    } catch (err) {
      console.error(err);
    }
  };

  const MicButton = () => (
    <button
      className="btn btn-secondary ms-2"
      onClick={startListening}
    >
      {listening ? "Listening..." : "🎤"}
    </button>
  );

  // Handle send
  // const handleSend = async (value) => {
  //   if (timerRef.current) clearTimeout(timerRef.current);
  //   if (!input.trim()) return;
  //   const inputValue = value ?? input;

  //   if (!inputValue || (typeof inputValue === "string" && !inputValue.trim())) return;

  //   const handleMicInput = (transcript) => {
  //     const spoken = transcript.trim().toLowerCase();

  //     if (type === "radio" || type === "dropdown") {
  //       const match = options.find(opt =>
  //         (opt.label || opt).toLowerCase() === spoken || (opt.value || opt).toLowerCase() === spoken
  //       );
  //       if (match) handleSend(match.value || match.label || match);
  //     }
  //     else if (type === "checkbox") {
  //       // For simplicity, add spoken option if exists in options
  //       const matches = options.filter(opt => (opt.label || opt).toLowerCase() === spoken || (opt.value || opt).toLowerCase() === spoken);
  //       if (matches.length > 0) handleSend(matches.map(m => m.value || m.label || m));
  //     }
  //     else {
  //       setInput(transcript);
  //       handleSend(transcript);
  //     }
  //   };

  //   const micButton = (
  //     <button className="btn btn-secondary ms-2" onClick={startListening}>
  //       {listening ? "Listening..." : "🎤"}
  //     </button>
  //   );

  //   // Add user message
  //   // setMessages(prev => [...prev, { type: "user", text: input }]);
  //   let displayText = input;

  //   if (type === "dropdown") {
  //     const selected = options.find(opt => opt.value === input);
  //     displayText = selected ? selected.label : input;
  //   }

  //   setMessages(prev => [...prev, { type: "user", text: displayText }]);

  //   // Prepare stepData
  //   let stepData = {};
  //   fields.forEach(field => {
  //     stepData[field] = input; // Single input for now; if multiple fields, can split by comma or use multiple messages
  //   });

  //   setInput(""); // clear input

  //   try {
  //     const res = await fetch(`${BACKEND_URL}/snapshot/step`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         sessionId,
  //         stepData
  //       })
  //     });

  //     const data = await res.json();

  //     if (data.error) {
  //       setMessages(prev => [...prev, { type: "bot", text: `Error: ${data.error}` }]);
  //       return;
  //     }

  //     if (data.completed) {
  //       // setMessages(prev => [...prev, { type: "bot", text: data.message }]);
  //       // setCompleted(true);
  //       setCompletedData(true);
  //       setFinaldata(data.data);
  //       setFields([]);
  //     } else {
  //       setFields(data.fields);
  //       setType(data.type || "text");
  //       setStep(data.step);
  //       setOptions(data.options || []);
  //       setTitle(data.title);
  //       setMessages(prev => [...prev, { type: "bot", text: data.message }]);
  //     }

  //     if (data.reviewData) {
  //       setReviewData(data.reviewData);
  //       setFinaldata(data.reviewData);
  //     }

  //     inputRef.current?.focus();
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const handleSend = async (value) => {
    // ✅ stop timer
    if (timerRef.current) clearTimeout(timerRef.current);

    // ✅ use passed value OR state
    const inputValue = value ?? input;

    // ✅ validation
    if (
      !inputValue ||
      (typeof inputValue === "string" && !inputValue.trim()) ||
      (Array.isArray(inputValue) && inputValue.length === 0)
    ) {
      return;
    }

    // ✅ resolve display text (important for dropdown + checkbox)
    let displayText = inputValue;

    if (type === "radio" || type === "dropdown") {
      const selected = options.find(opt => opt.value === inputValue);
      displayText = selected ? selected.label : inputValue;
    }

    // checkbox
    else if (type === "checkbox") {
      const selectedLabels = options
        .filter(opt => inputValue.includes(opt.value))
        .map(opt => opt.label);

      displayText = selectedLabels.join(", ");
    }

    // ✅ add user message
    setMessages(prev => [
      ...prev,
      { type: "user", text: displayText }
    ]);

    // ✅ prepare stepData
    let stepData = {};
    fields.forEach(field => {
      stepData[field] = inputValue;
    });

    // ✅ clear input
    setInput(type === "checkbox" ? [] : "");

    try {
      const res = await fetch(`${BACKEND_URL}/snapshot/step`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sessionId,
          stepData
        })
      });

      const data = await res.json();

      // ❌ error handling
      if (data.error) {
        setMessages(prev => [
          ...prev,
          { type: "bot", text: `Error: ${data.error}` }
        ]);
        return;
      }

      // ✅ completed flow
      if (data.completed) {
        setCompletedData(true);
        setFinaldata(data.data);
        setFields([]);
        return;
      }

      // ✅ next step
      setFields(data.fields);
      setType(data.type || "text");
      setStep(data.step);
      setOptions(data.options || []);
      setTitle(data.title);

      setMessages(prev => [
        ...prev,
        { type: "bot", text: data.message }
      ]);

      // ✅ review data
      if (data.reviewData) {
        setReviewData(data.reviewData);
        setFinaldata(data.reviewData);
      }

      // ✅ focus input
      inputRef.current?.focus();

    } catch (err) {
      console.error("handleSend error:", err);
    }
  };

  // Handle Enter key
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <>
      <WorkerHeader />
      <div className="container-fluid mb-4">
        <div className="container-sm">
          <div className="card shadow mt-4 mx-auto chat-wrapper">

            {/* HEADER */}
            <div
              className="header d-flex align-items-center px-3"
              style={{ backgroundColor: "rgb(0, 43, 69)", minHeight: "70px" }}
            >
              <div className="profile me-3">
                <img
                  src="/assets/images/worker_bot.png"
                  alt="profile-avatar"
                  className="rounded-circle"
                  style={{ height: "55px", width: "55px", objectFit: "cover" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center w-100 flex-wrap">
                <div style={{ color: "#fff" }}>
                  <h4 className="mb-0">Emily</h4>
                  <small>NCAF Readiness Compliance Assistant</small>
                </div>
              </div>
            </div>

            <div className="p-2">
              {/* PROGRESS BAR */}
              <div className="progress mb-3">
                <div
                  className="progress-bar d-flex align-items-center justify-content-center"
                  role="progressbar"
                  style={{
                    width: `${progressPercent}%`,
                    background: "#002B45",
                    color: "#fff",
                    fontWeight: "500"
                  }}
                >
                  {progressPercent}%
                </div>
              </div>
              {/* <div style={{ fontSize: "14px", color: timeLeft <= 5 ? "red" : "#333" }}>
                {type !== "text" && !onboardingStatus && (
                  <div>⏳ {timeLeft}s</div>
                )}
              </div> */}

              {/* CHAT BODY */}
              <div className="chat-body" ref={chatContainerRef} > {/* style={{ maxHeight: "400px", overflowY: "auto", marginBottom: "20px" }} */}
                {messages.map((msg, idx) => (
                  <div key={idx} >

                    {/* ✅ USER MESSAGE */}
                    {msg.type === "user" && (
                      <div className="user-msg">
                        <p className="mb-0">{msg.text} {msg.sender}</p>
                      </div>
                    )}

                    {/* ✅ BOT MESSAGE */}
                    {msg.type === "bot" && (
                      <div className="bot-msg">
                        <p className="mb-0">{msg.text}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {!completedData && (
                <div className="chat-input-container p-2 border-2">
                  <div className="input-group chat-input shadow-sm">

                    {/* RADIO */}
                    {type === "radio" && (
                      <div className="d-flex flex-wrap gap-2">
                        {options.map((option, index) => (
                          <>
                            <button
                              key={index}
                              onClick={() => handleRadioSelect(option)}
                              style={{ backgroundColor: "rgb(0, 43, 69)", color: "#fff" }}
                              className="btn btn-sm"
                            >
                              {typeof option === "object" ? option.label : option}
                            </button>
                          </>
                        ))}
                        <MicButton />
                      </div>
                    )}

                    {/* DROPDOWN */}
                    {type === "dropdown" && (
                      <div className="d-flex align-items-center gap-2" style={{ width: "100%" }}>
                        <select className="form-select rounded-pill" value={input} onChange={(e) => {
                          const val = e.target.value;

                          if (timerRef.current) clearTimeout(timerRef.current);

                          setInput(val);
                          if (val) handleSend(val);
                        }} >
                          <option value="">Select option</option>
                          {options.map((opt, index) => (<option key={index} value={opt.value}> {opt.label} </option>))}
                        </select>
                        {/* <button onClick={handleSend} className="btn bg-white border-0" > <i className="bi bi-send me-2"></i> </button> */}
                        <MicButton />
                      </div>
                    )}

                    {/* CHECKBOX MULTI SELECT */}
                    {type === "checkbox" && (
                      <div className="card p-3 border-0 shadow-sm rounded-4">
                        {options.map((option, index) => (
                          <div key={index} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={option.value}
                              id={`checkbox-${index}`}
                              checked={input?.includes(option.value)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setInput(prev => [...(prev || []), option.value]);
                                  setLabel(prev => [...(prev || []), option.label]);
                                } else {
                                  setInput(prev =>
                                    prev.filter(item => item !== option.value)
                                  );
                                  setLabel(prev =>
                                    prev.filter(item => item !== option.label)
                                  );
                                }
                              }} ce
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`checkbox-${index}`}
                            >
                              {option.label}
                            </label>
                          </div>
                        ))}

                        <MicButton />
                        <button className="btn btn-primary mt-2" onClick={async () => {
                          if (!input || input.length === 0) return;
                          console.log(input);
                          console.log(label);
                          setMessages(prev => [
                            ...prev,
                            { type: "user", text: label.join(',') }
                          ]);

                          const stepData = {
                            [fields]: input
                          };

                          const res = await fetch(`${BACKEND_URL}/snapshot/step`, {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                              sessionId,
                              stepData
                            })
                          });

                          const data = await res.json();

                          if (data.completed) {
                            // setMessages(prev => [...prev, { type: "bot", text: data.message }]);
                            // setCompleted(true);
                            setCompletedData(true);
                            setFinaldata(data.data);
                            return;
                          }

                          if (data.reviewData) {
                            setReviewData(data.reviewData);
                          }

                          setFields(data.fields);
                          setType(data.type || "text");
                          setOptions(data.options || []);
                          setTitle(data.title);
                          setStep(data.step);
                          setMessages(prev => [...prev, { type: "bot", text: data.message }]);
                          setInput(data.type === "checkbox" ? [] : "");
                          setLabel([]);
                        }}
                        >
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

            </div>

            {!completedData && (
              <>
                {type === "text" && (
                  <>
                    <div className="d-flex gap-2 align-items-center p-3" style={{ width: "100%" }}>
                      <input type="text" value={input} onKeyDown={handleKeyDown} onChange={e => setInput(e.target.value)} placeholder="Enter answer..." className="form-control" />
                      <button
                        className="btn bg-white "
                        onClick={() => handleSend()}
                        disabled={!input && type === "text"}
                      >
                        {/* <FaPaperPlane size={18} className="text-primary" /> */}
                        <i className="bi bi-send me-2"></i>
                      </button>
                      <MicButton />
                    </div>

                  </>
                )}
              </>
            )}

          </div>
          {loading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.4)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999
              }}
            >
              <div className="spinner-border text-light" style={{ width: "3rem", height: "3rem" }} />
            </div>
          )}

          {onboardingStatus && (
            <div class="card shadow mt-4 mx-auto chat-wrapper">
              <div className="text-center py-5">

                {onboardingStatus === "success" && (
                  <>
                    {/* <div style={{ fontSize: "60px" }}>🎉</div>
                    <h3 className="text-success mt-3">
                      Snapshot submited Successfully!
                    </h3> */}
                    {onboardingStatus === "success" && submittedSnapshot && (
                      <>
                        <div style={{ fontSize: "60px" }}>🎉</div>

                        <h2 className="text-success mt-3 fw-bold">
                          Thank You!
                        </h2>

                        <p className="text-muted mb-4">
                          Your <strong>Benefits Readiness Snapshot</strong> has been submitted
                          successfully. Our team will review your submission and contact you if
                          any additional information is needed.
                        </p>

                        {/* Submitted Information */}
                        <div className="card shadow-sm border-0 mb-4 text-start p-4">
                          <div className="card-header bg-primary text-white fw-bold">
                            Submitted Information
                          </div>

                          <div className="card-body">
                            <div className="row mb-3">
                              <div className="col-md-4 fw-semibold">Center Name</div>
                              <div className="col-md-8">{submittedSnapshot.center_name}</div>
                            </div>

                            <div className="row mb-3">
                              <div className="col-md-4 fw-semibold">Email</div>
                              <div className="col-md-8">{submittedSnapshot.email}</div>
                            </div>

                            <div className="row mb-3">
                              <div className="col-md-4 fw-semibold">ZIP Code</div>
                              <div className="col-md-8">{submittedSnapshot.zip_code}</div>
                            </div>

                            <div className="row">
                              <div className="col-md-4 fw-semibold">Acknowledgment</div>
                              <div className="col-md-8">
                                {submittedSnapshot.acknowledgment ? "Yes" : "No"}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Responses */}
                        <div className="card shadow-sm border-0 text-start p-4">
                          {/* <div className="card-header bg-success text-white fw-bold">
                            Your Responses
                          </div> */}

                          <div className="card-body p-0">
                            <table className="table table-hover align-middle mb-0">
                              <thead>
                                <tr>
                                  <th style={{ width: "45%" }}>Question</th>
                                  <th>Answer</th>
                                </tr>
                              </thead>

                              <tbody>
                                {submittedSnapshot.answers.map((item, index) => (
                                  <tr key={index}>
                                    <td className="fw-semibold">
                                      {questionLabels[item.que_name] || item.que_name}
                                    </td>

                                    <td>
                                      {getAnswerLabel(item.que_name, item.answer)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div>
                          <button
                            type="button"
                            className="btn btn-primary mt-4"
                            onClick={() => {
                              const attribution = getActiveAttribution();
                              window.dataLayer = window.dataLayer || [];
                              window.dataLayer.push({
                                event: "free_pilot_cta_clicked",
                                entry_flow: "pre_login",
                                entry_page: "/free-pilot-registration",
                                authentication_status: "guest",
                                provider_user_id: undefined,
                                utm_source: attribution.utm_source || "free_pilot",
                                utm_medium: attribution.utm_medium,
                                utm_campaign: attribution.utm_campaign,
                                utm_content: attribution.utm_content,
                                utm_term: attribution.utm_term,
                              });

                              navigate("/free-pilot-registration");
                            }}
                          >
                            Continue to 30-Day Free Trial Registration
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}

                {onboardingStatus === "failed" && (
                  <>
                    <div style={{ fontSize: "60px" }}>❌</div>
                    <h3 className="text-danger mt-3">
                      Snapshot Failed
                    </h3>
                    <p className="text-muted">
                      Something went wrong. Please try again.
                    </p>

                    <button
                      className="btn btn-primary mt-3"
                      onClick={() => setOnboardingStatus(null)}
                    >
                      Try Again
                    </button>
                  </>
                )}

              </div>
            </div>
          )}


        </div>
      </div>

      {/* Modal */}
      <div
        className="modal fade"
        id="addComplianceModal"
        tabIndex="-1"
        aria-labelledby="addComplianceModalLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addComplianceModalLabel">
                Sanpshot Overview
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="container-fluid py-3">
                <div className="text-center mb-4">
                  <h3 className="fw-bold text-primary">Snapshot Overview</h3>
                  <p className="text-muted mb-0">
                    Please review your answers before submitting
                  </p>
                </div>

                <div className="row g-4">
                  {Object.entries(reviewData || {}).map(([key, value]) => {
                    const options = optionMap[key];

                    let displayValue = value;

                    if (options) {
                      if (Array.isArray(value)) {
                        displayValue = options
                          .filter(opt => value.includes(opt.value))
                          .map(opt => opt.label)
                          .join(", ");
                      } else {
                        const selected = options.find(opt => opt.value === value);
                        displayValue = selected ? selected.label : value;
                      }
                    }

                    const formatKey = key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, str => str.toUpperCase());

                    return (
                      <div className="col-md-6" key={key}>
                        <div
                          className="p-4 rounded-4 h-100"
                          style={{
                            background: "#f8f9fa",
                            border: "1px solid #e9ecef",
                            transition: "all 0.2s ease-in-out"
                          }}
                        >
                          <div className="text-muted small mb-1">
                            {formatKey}
                          </div>

                          <div
                            className="fw-semibold"
                            style={{
                              fontSize: "15px",
                              color: "#002B45"
                            }}
                          >
                            {displayValue || "N/A"}
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* Buttons */}
                  <div className="col-12 mt-4">

                    <div className="mb-3 px-3">
                      <div className="form-check d-flex align-items-start justify-content-center gap-2">
                        <input
                          className="form-check-input mt-1"
                          type="checkbox"
                          id="marketingConsent"
                          checked={marketingConsent}
                          onChange={(e) => setMarketingConsent(e.target.checked)}
                        />

                        <label
                          className="form-check-label text-muted"
                          htmlFor="marketingConsent"
                          style={{ fontSize: "0.9rem", lineHeight: "1.5" }}
                        >
                          I agree to receive marketing communications, updates, and
                          information about NCAF programs, resources, and services.
                          I understand that this consent is optional and I may
                          unsubscribe at any time.
                        </label>
                      </div>
                    </div>

                    {/* ✅ Disclaimer / Statement */}
                    <div className="mb-3 text-center px-3">
                      <p style={{ fontSize: "0.85rem", color: "#6c757d", lineHeight: "1.5" }}>
                        NCAF provides benefits-readiness guidance, education, and partner coordination support only.
                        NCAF does not sell, sponsor, administer, underwrite, or guarantee health insurance or employee
                        benefit plans. Any insurance, HRA, ACA enrollment, payroll, tax, or legal determination must
                        be completed directly with qualified licensed or authorized partners.
                      </p>
                    </div>

                    <div className="d-flex justify-content-center gap-3">
                      <button
                        className="btn btn-primary px-5 py-2 rounded-pill shadow-sm"
                        // onClick={() => handleSubmit("confirm")}
                        onClick={submitSnapshot}
                        style={{
                          background: "linear-gradient(135deg, #0d6efd, #4dabf7)",
                          border: "none",
                          fontWeight: "500"
                        }}
                      >
                        Go Ahead
                      </button>

                      <button
                        className="btn btn-primary px-5 py-2 rounded-pill shadow-sm"
                        // onClick={() => handleSubmit("change")}
                        onClick={() => handleRadioSelect("change")}
                        style={{
                          background: "linear-gradient(135deg, #0d6efd, #4dabf7)",
                          border: "none",
                          fontWeight: "500"
                        }}
                      >
                        Change Anything
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <WorkerFooter />
    </>
  );
};

export default WorkerBotChat;
